import {Offcanvas, Collapse, Modal} from 'bootstrap';
import Typesense from 'typesense';
import {autocomplete} from '@algolia/autocomplete-js';
import { SearchResponseAdapter } from 'typesense-instantsearch-adapter/lib/SearchResponseAdapter';
import { createLocalStorageRecentSearchesPlugin } from '@algolia/autocomplete-plugin-recent-searches';
import ReadMore from 'readmore-js';
import './../stars/stars.ts';
import * as mapping from 'knockout-mapping';
import 'custom-knockout';
import ko from 'knockout';
import * as Ladda from 'ladda';
import 'cash-dom';
import axios from 'axios';

//import * as Sentry from "@sentry/browser";
import val from "../val";
import KeyUpEvent = JQuery.KeyUpEvent;
import {DateTime, Duration} from "luxon";

window.dataLayer = window.dataLayer || [];

// Sentry.init({
//     dsn: "https://ab653df73ac6e04968f748b14a289044@o4506654190862336.ingest.us.sentry.io/4508908456443904",
//     integrations: [
//         Sentry.browserTracingIntegration(),
//         Sentry.replayIntegration({
//             maskAllText: false,
//             blockAllMedia: false,
//             networkDetailAllowUrls: ['(.*?)']
//         }),
//     ],
//     // Tracing
//     tracesSampleRate: 1.0, //  Capture 100% of the transactions
//     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//     tracePropagationTargets: ["floordepot\.web", /^https:\/\/floordepot\.co.\.uk/],
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });



function setCookie(name, value, days){
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    var expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + value + expires + ";path=/";
}
function getParam(p){
    var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}
var gclid = getParam('gclid');
if(gclid){
    var gclsrc = getParam('gclsrc');
    if(!gclsrc || gclsrc.indexOf('aw') !== -1){
        setCookie('gclid', gclid, 90);
        var date = new Date();
        setCookie('gclid_d', date.toISOString(), 90);
    }
}

function readCookie(name) {
    var n = name + "=";
    var cookie = document.cookie.split(';');
    for(var i=0;i < cookie.length;i++) {
        var c = cookie[i];
        while (c.charAt(0)==' '){c = c.substring(1,c.length);}
        if (c.indexOf(n) == 0){return c.substring(n.length,c.length);}
    }
    return null;
}

export class Common {

    constructor() {
        this.initExtensions();
        this.initPlugins();
        this.initSamplesKO();

        // new
        //HeaderHeight();
    }
    
    initSamplesKO() {
        let json = $("#cart-data").text();
        var data = mapping.fromJSON(json);

        data.CrossSellUnderlays = ko.observableArray([]);
        
        function updateBasketTotals(basket) {
            mapping.fromJS(basket, {}, data.Basket);
            updateDeliveryDiscountTimer();
        }
        
        function updateDeliveryDiscountTimer() {
            if (data.Basket.DiscountedDeliveryExpireDate != undefined) {
                var timerSecs = DateTime.fromISO(data.Basket.DiscountedDeliveryExpireDate());
                var now = DateTime.now();
                var diff = timerSecs.diff(now, 'seconds');
                data.timer(diff);
            }
        }
        
        data.cartTab = ko.observable('cart');
        data.timer = ko.observable(0).extend({ notify: 'always' });
        data.expires = ko.observable('');
        data.itemJustAddedWithUnderlayCrossSellOptions = ko.observable(false);
        data.SelectedUnderlayId = ko.observable(0);
        data.ItemsJustAdded = ko.observableArray([]);
        data.SelectUnderlay = function(item) {
            var id = item.Id != undefined ? item.Id : 0;
            data.SelectedUnderlayId(id);
            return true;
        }
        data.confirmCrossSellUnderlay = async function(item) {
            var l = Ladda.create(document.querySelector('#add-underlay-btn'));
            l.start();
            
            var underlayId = data.SelectedUnderlayId();
            
            if (underlayId == 0) {
                l.stop();
                data.itemJustAddedWithUnderlayCrossSellOptions(false);
                return false;
            }
            
            var underlayItem = ko.utils.arrayFirst(data.CrossSellUnderlays(), function (item) {
                return item.Id == underlayId;
            });

            if (underlayItem == null) {
                l.stop();
                data.itemJustAddedWithUnderlayCrossSellOptions(false);
                return false;
            }
            
            var inputModel = {
                productId: underlayId,
                qty: underlayItem.QtyRequired,
                crossSellProducts: []
            }
            
            try {
                var result = await axios.post('/basket/add', inputModel)
                updateBasketTotals(result.data);
                l.stop();
                data.itemJustAddedWithUnderlayCrossSellOptions(false);
            }
            catch(err) {
                l.stop();
                data.itemJustAddedWithUnderlayCrossSellOptions(false);
            }
        }
        
        data.timer.subscribe(function() {
            var timerSecs = DateTime.fromISO(data.Basket.DiscountedDeliveryExpireDate());
            var now = DateTime.now();
            var duration =  timerSecs.diff(now, ['hours', 'minutes', 'seconds']).toObject();
            var d = Duration.fromObject(duration);
            var formatted = d.toFormat('hh:mm:ss'); //DateTime.utc(d.as('seconds')*1000).toFormat('HH:mm:ss');
            data.expires(formatted);
        });

        setInterval(function() {
            var newTimer = data.timer() - 1;
            data.timer(newTimer <= 0 ? 0 : newTimer);
        }, 1000);

        
        data.sum = function(items, prop){
            return items.reduce( function(a, b){
                return a + b[prop]();
            }, 0);
        };
        
        data.basketCount = ko.computed(function() {
            var items = ko.utils.arrayFilter(data.Basket.Items(), function (item:any) {
                return item.IsSample() == false;
            });
            return data.sum(items, 'Qty');
        });
        data.sampleCount = ko.computed(function() {
            var items = ko.utils.arrayFilter(data.SampleBasketItems(), function (item:any) {
                return item.IsSample() == true;
            });
            return data.sum(items, 'Qty');
        });
        
        data.cartCount = ko.computed(function() {
            var totalBasket = data.basketCount();
            var totalSamples = data.sampleCount();
            $(".cart-nav-count").attr('data-cart-items', totalBasket);
            $(".cart-mobile-nav-count").text(totalBasket);
            $(".cart-nav-sample-count").attr('data-cart-items', totalSamples);
            $(".cart-mobile-nav-sample-count").text(totalSamples)
        });
        
        data.removeCartItem = async function(item) {
            
            try {
                var result = await axios.delete('/basket/deleteproduct/' + item.ProductId());
                data.Basket.Items.remove(item);
                // we are good, already removed from view
                updateBasketTotals(result.data);
            }
            catch(err) {
                console.log('failed to remove from basket')
            }
        }
        
        
        data.useActiveCode = function() {
            data.Basket.CustomersDiscountCode(data.Discount.Code());
        }
        
        data.applyPromoCode = async function(item, evnt) {
            var code = data.Basket.CustomersDiscountCode();
            var email = data.Basket.Email();

            (window as any).klaviyo.identify({
                "email" :email,
                "promo_code": code
            }, function(e){
                console.log("Klaviyo identity has been completed")
            });
            var url = '/basket/apply-discount';
            
            $(".btnapplypromo").addClass('disabled');

            try {
                var result = await axios.put(url, {
                    CustomerDiscountCode: code,
                    Email: email
                });

                updateBasketTotals(result.data);
                $(".btnapplypromo").removeClass('disabled');
                $("#promo-code-error").text("");
            }
            catch(err) {
                console.log(err);
                val.displayErrors(err.response.data, "#promo-code-error");

                if (err.response.data.CustomerDiscountCode != null) {
                    var codeErr = err.response.data.CustomerDiscountCode[0];
                    $("#promo-code-error").text(codeErr);
                }

                $(".btnapplypromo").removeClass('disabled',);
            }
            
        }
        
        data.removePromoCode = async function(item) {
            var url = '/basket/remove-discount'

            try {
                var result = await axios.put(url);
                updateBasketTotals(result.data);
            }
            catch(err) {
                var codeErr = err.response.data.customerDiscountCode[0];
                $("#add-discount-code-error").text(codeErr);
            }
        }
        
        data.updateBasketDelivery = async function(item, event) {
            if (event.isTrusted) { //user changed, not programmatic by knockout etc
                var val = event.currentTarget.value;
                var url = '/basket/updatedelivery/' + val;

                try {
                    var result = await axios.post(url);
                    updateBasketTotals(result.data);
                } catch (err) {
                    console.log(err)
                }
            }
           
        }
        
        data.addXmoreSamples = ko.computed(function() {
            return (3 - data.SampleBasketItems().length);
        });
        
        data.removeSample = async function(item:any) {
            
            try {
                var result = await axios.delete('/basket/deletesample/' + item.ProductId());
                data.SampleBasketItems.remove(item);
            }
            catch(err) {
                console.log('failed to remove sample')
            }
           
        };
        
        $(function() {

            updateDeliveryDiscountTimer();
            
            ko.applyBindings(data, $("#sideCart")[0]);
            
            $(".nav-samples-cart").on('click', function() {
                var ctx = ko.contextFor($("#sideCart")[0]);
                ctx.$data.cartTab('samples');
            });
            $(".nav-basket").on('click', function() {
                var ctx = ko.contextFor($("#sideCart")[0]);
                ctx.$data.cartTab('cart');
            });

            $("#sideCart").on('keyup', '.qty', async function(e:KeyUpEvent) {
                var value = e.currentTarget.value;
               var item = ko.dataFor(this);
                var val2 = [{id: item.ProductId(), qty: value}];
                
                if (isNaN(parseInt(value)))
                    return;
                
                try {
                    var result = await axios.post('/basket/upateqtys', val2)
                    $("#sideCart-errors").text('');
                    updateBasketTotals(result.data);
                }
                catch(err) {
                    console.log(err);
                    val.displayErrors(err.response.data, '#sideCart-errors');
                } 
                
            });


            if (data.SampleBasketItems() != null && data.SampleBasketItems().length == 3) {
                $(".btnaddsample")
                    .addClass('disabled').text('Max 3 Samples');
            }
            
            $("body").on('click', '.btnaddsample', async function (e) {
                e.preventDefault();

                var btn = $(this);
                var productData = $(this).attr('data-product');
                var productDataDeserialized = JSON.parse(productData);
                
                // check if this product id already exists
                var existing = ko.utils.arrayFirst(data.SampleBasketItems(), function(item:any) {
                    return item.ProductId() == productDataDeserialized.ProductId;
                });
                
                if (existing != null) {
                   btn.addClass('disabled');
                   
                    // remove via ajax, and toggle button class
                    try {
                        var deleteResult = await axios.delete('/basket/deletesample/' + productDataDeserialized.ProductId);
                        btn.removeClass('inbasket').removeClass('disabled');
                        data.SampleBasketItems.remove(existing);
                    }
                    catch(err) {
                        btn.removeClass('disabled');
                    }
                    return;
                }
                
                // max 3 allowed, safety net
                if (data.SampleBasketItems() != null && data.SampleBasketItems().length == 3) {
                    return false;
                }

                // switch tab to samples
                data.cartTab('samples');
                
                var url = $(this).attr('href');
                var mappedPr = mapping.fromJS(productDataDeserialized);

                // add to our client js first, so its instant   
                data.SampleBasketItems.push(mappedPr)

                var myOffcanvas = document.getElementById('sideCart')
                var bsOffcanvas = new Offcanvas(myOffcanvas)
                bsOffcanvas.show()
                
                btn.addClass('inbasket');
                
                try {
                    var result = await axios.get(url);
                    if (data.SampleBasketItems().length == 3)
                        $("#btnaddsample").text('Sample Limit Reached')
                            .attr('disabled', 'true')
                            .addClass('disabled');
                }
                catch(err) {
                    console.log('error');
                    $("#basketerror").removeClass('d-none');
                }
            });
        });
        
    };
    
    
    initPlugins() {

        window.onload = function() {
            var event = new Event('change');
            
            if (document.getElementById('gclid_field') != null) {
                (document.getElementById('gclid_field') as HTMLInputElement).value = readCookie('gclid');
                (document.getElementById('gclid_field') as HTMLInputElement).dispatchEvent(event);
            }
            if (document.getElementById('gclid_d_field') != null) {
                (document.getElementById('gclid_d_field') as HTMLInputElement).value = readCookie('gclid_d');
                (document.getElementById('gclid_d_field') as HTMLInputElement).dispatchEvent(event);
            }
        }

        document.addEventListener("wheel", function(event:any){
            if((document.activeElement as any).type === "number" &&
                document.activeElement.classList.contains("noscroll"))
            {
                (document.activeElement as any).blur();
            }
        });
        
      
        $('.navbar-toggler').on('click', function() {
            var toggle = $('.navbar-toggler').is(':visible');
            if (toggle) {
                $('header').toggleClass('header-toggle');
            }
        })

        var mDropdown = $(".px-dropdown-toggle")
        mDropdown.on("click", function() {
            $(this).parents("li").toggleClass("open-menu-parent");
            $(this).parents("li").find(".dropdown-menu").toggleClass("show");
            $(this).parent().find(".mob-menu").toggleClass("open");
        });

        new ReadMore('.read-more-content-item', {
            speed: 75,
            collapsedHeight: 85,
            lessLink: '<a href="#">Read less</a>'
        });

        $(".footer").on('click', 'h6', function(e) {
            e.preventDefault();

            var el = $(this).parent().find("ul.ft-menu-content");
            if (el.css('display') == 'none') {
                el.show();
            } else {
                el.hide();
            }
        });
    }

    initExtensions() {
        
        function setupNav() {
            if ($(window).width() <= 831) {
                $(".nav-link.dropdown-toggle").removeAttr("data-bs-hover");
                $(".nav-link.dropdown-toggle").attr("data-bs-toggle", "dropdown");
            } else {
                $(".nav-menu > li").removeAttr("data-bs-toggle");
                $(".nav-link.dropdown-toggle").attr("data-bs-hover", "dropdown");
            }
        }

        function initSearch(inputEl) {
            let typesenseClient = new Typesense.Client({
                'nearestNode': {'host': 'nb90pixysfd5ual2p-1.a1.typesense.net', 'port': 443, 'protocol': 'https'},
                'nodes': [
                    {'host': 'nb90pixysfd5ual2p-1.a1.typesense.net', 'port': 443, 'protocol': 'https'},
                ],
                'apiKey': 'Rs9nHJQYIUDvKEGKo4JyaZpR6eb2LSER',
                'connectionTimeoutSeconds': 2
            })

            const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
                key: 'RECENT_SEARCH',
                limit: 5,
            });

            var myOffcanvas = document.getElementById('sideSearch')
            myOffcanvas.addEventListener('shown.bs.offcanvas', function () {
                $(".aa-Input").trigger('focus');
            })
            
            const search_response_adapter = (result) =>
                new SearchResponseAdapter(
                    result,
                    { params: {} },
                    { geoLocationField: '_geoloc' }
                );

            var searchApi = autocomplete<Record<string, unknown>>({
                container: inputEl,
                openOnFocus: true,
                autoFocus: true,
                placeholder: 'Search for a product...',
                plugins: [recentSearchesPlugin],
                
                onSubmit(params: any) {
                    window.location.href = '/search?query=' + encodeURIComponent(params.state.query);
                },
                onReset(params: any) {

                },
                async getSources({query}) {

                    return [
                        {
                            sourceId: 'predictions',
                            async getItems() {
                                var r = await typesenseClient
                                    .collections('Products2')
                                    .documents()
                                    .search({
                                        q: query,
                                        query_by: 'categorynames,name2,sku,shortname,facets.Colour,facets.Shade,facets.Thickness,facets.Style / Features',
                                        filter_by: 'discontinued:=false && isdeleted:=false && ispublished:=true',
                                        sort_by: 'searchboost:desc,_text_match:desc',
                                        highlight_full_fields: 'name2',
                                        infix: 'fallback'
                                    });

                                return search_response_adapter(r).adapt().hits;

                            },
                            getItemUrl({ item }) {
                                return '/item/' + item.id + '/' + item.slug;
                            },
                            getItemInputValue({item}) {
                                return (item as any).name;
                            },
                            templates: {
                                item({ item, html, state }) {
                                    return html`<a href="/item/${item.id}/${item.slug}"><div class="single-item">
                                        <img src="https://ik.imagekit.io/floordepot/tr:n-prod_thumb2/${item.defaultmediafilename}" width="70" height="70" />
                                        <div class="product_details">
                                            <div class="product_name">${item.name2}</div>
                                            <div class="product_price">
                                                <div class="d-flex flex-row gap-3">
                                                    <div>
                                                        ${((item.promoprice as number) > 0 ? 'From ' : '')} 
                                                        £${(((item.promoprice as number) > 0 ? item.promoprice : item.price) as number).toFixed(2)}${(item.ism2product ? "m2" : "")}
                                                    </div>
                                                    <div>
                                                        <span class="was-price">${((item.promoprice as number) > 0 ? 'Was £' + (item.price as number).toFixed(2) : '')}${((item.promoprice as number) > 0 && item.ism2product ? "m2" : "")}</span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div></a>`;
                                },
                            },
                        },
                    ];
                },
            });
            
            return searchApi;
        }
        
        
    setupNav();
    $(window).on('resize', setupNav);

    var searchApi = initSearch("#autocomplete_main")
    
    $(".openSearch").on('click', function() {
        searchApi.setIsOpen(true);
    })
   
    
        
        
        
    }
}

let common = new Common();
